import { useQuery } from "@tanstack/react-query";
import { getClaimsBanners } from "@leagueplatform/claims-api";
import { useParams } from "react-router-dom";

const GET_CLAIMS_BANNERS_MESSAGE_TYPE = "get_claims_banners";
const STALE_TIME = 1000 * 60 * 5;

export const useServiceDetailsBanner = () => {
  const { claimId } = useParams();

  return useQuery({
    queryKey: [GET_CLAIMS_BANNERS_MESSAGE_TYPE, claimId],
    queryFn: () =>
      getClaimsBanners({ pathParams: { claimId: claimId as string } }),
    select: (response) => response.data[0]?.attributes,
    staleTime: STALE_TIME,
    enabled: Boolean(claimId),
  });
};
